import { useMemo } from 'react';
import { useContextMenu } from '../useContextMenu/useContextMenu';
import { useTooltip } from '../useTooltip/useTooltip';
import { useZoom } from '../useZoom/useZoom';
export function useUIHandlers(opts) {
    const { props, state, view } = opts;
    const { onContextMenuShow, onContextMenuHide, contextMenu } = useContextMenu({
        props,
        state,
        handlers: opts.handlers,
    });
    const { onTooltipShow, onTooltipHide, tooltip } = useTooltip();
    const onZoom = useZoom({ state, view });
    const handlers = useMemo(() => ({
        onContextMenuShow,
        onContextMenuHide,
        onTooltipShow,
        onTooltipHide,
        onZoom,
    }), [
        onContextMenuShow,
        onContextMenuHide,
        onTooltipShow,
        onTooltipHide,
        onZoom,
    ]);
    const elements = useMemo(() => ({
        contextMenu,
        tooltip,
    }), [contextMenu, tooltip]);
    return {
        handlers,
        elements,
    };
}
